/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BuildingResponse', 'model/BusinessResponse', 'model/IDeliveryItemV2Request', 'model/IInvoiceItemV2Request', 'model/IInvoiceItemV2Response', 'model/InvoiceV2Response', 'model/LocationResponse', 'model/SiteResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BuildingResponse'), require('./BusinessResponse'), require('./IDeliveryItemV2Request'), require('./IInvoiceItemV2Request'), require('./IInvoiceItemV2Response'), require('./InvoiceV2Response'), require('./LocationResponse'), require('./SiteResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.InvoiceV2Response = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.BuildingResponse, root.BpmbuildProductionappspotcom.BusinessResponse, root.BpmbuildProductionappspotcom.IDeliveryItemV2Request, root.BpmbuildProductionappspotcom.IInvoiceItemV2Request, root.BpmbuildProductionappspotcom.IInvoiceItemV2Response, root.BpmbuildProductionappspotcom.InvoiceV2Response, root.BpmbuildProductionappspotcom.LocationResponse, root.BpmbuildProductionappspotcom.SiteResponse);
  }
}(this, function(ApiClient, BuildingResponse, BusinessResponse, IDeliveryItemV2Request, IInvoiceItemV2Request, IInvoiceItemV2Response, InvoiceV2Response, LocationResponse, SiteResponse) {
  'use strict';

  /**
   * The InvoiceV2Response model module.
   * @module model/InvoiceV2Response
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>InvoiceV2Response</code>.
   * @alias module:model/InvoiceV2Response
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>InvoiceV2Response</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InvoiceV2Response} obj Optional instance to populate.
   * @return {module:model/InvoiceV2Response} The populated <code>InvoiceV2Response</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('vatToDisplay'))
        obj.vatToDisplay = ApiClient.convertToType(data['vatToDisplay'], 'String');
      if (data.hasOwnProperty('deliveryPostcode'))
        obj.deliveryPostcode = ApiClient.convertToType(data['deliveryPostcode'], 'String');
      if (data.hasOwnProperty('siteId'))
        obj.siteId = ApiClient.convertToType(data['siteId'], 'String');
      if (data.hasOwnProperty('collectedDate'))
        obj.collectedDate = ApiClient.convertToType(data['collectedDate'], 'Date');
      if (data.hasOwnProperty('deliveryDateToDisplay'))
        obj.deliveryDateToDisplay = ApiClient.convertToType(data['deliveryDateToDisplay'], 'String');
      if (data.hasOwnProperty('markUp'))
        obj.markUp = ApiClient.convertToType(data['markUp'], 'String');
      if (data.hasOwnProperty('quotationValue'))
        obj.quotationValue = ApiClient.convertToType(data['quotationValue'], 'String');
      if (data.hasOwnProperty('invoiceItemResponseList'))
        obj.invoiceItemResponseList = ApiClient.convertToType(data['invoiceItemResponseList'], [IInvoiceItemV2Response]);
      if (data.hasOwnProperty('targetCompletionDate'))
        obj.targetCompletionDate = ApiClient.convertToType(data['targetCompletionDate'], 'Date');
      if (data.hasOwnProperty('deliveryItemList'))
        obj.deliveryItemList = ApiClient.convertToType(data['deliveryItemList'], [IDeliveryItemV2Request]);
      if (data.hasOwnProperty('deliveryChargeToDisplay'))
        obj.deliveryChargeToDisplay = ApiClient.convertToType(data['deliveryChargeToDisplay'], 'String');
      if (data.hasOwnProperty('specificAddressRequired'))
        obj.specificAddressRequired = ApiClient.convertToType(data['specificAddressRequired'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('fileUrls'))
        obj.fileUrls = ApiClient.convertToType(data['fileUrls'], ['String']);
      if (data.hasOwnProperty('longDescription'))
        obj.longDescription = ApiClient.convertToType(data['longDescription'], 'String');
      if (data.hasOwnProperty('dateOrderReceived'))
        obj.dateOrderReceived = ApiClient.convertToType(data['dateOrderReceived'], 'Date');
      if (data.hasOwnProperty('dateOrderReceivedToDisplay'))
        obj.dateOrderReceivedToDisplay = ApiClient.convertToType(data['dateOrderReceivedToDisplay'], 'String');
      if (data.hasOwnProperty('imageUrls'))
        obj.imageUrls = ApiClient.convertToType(data['imageUrls'], ['String']);
      if (data.hasOwnProperty('invoiceItemList'))
        obj.invoiceItemList = ApiClient.convertToType(data['invoiceItemList'], [IInvoiceItemV2Request]);
      if (data.hasOwnProperty('shortDescription'))
        obj.shortDescription = ApiClient.convertToType(data['shortDescription'], 'String');
      if (data.hasOwnProperty('deliveryAddressLine1'))
        obj.deliveryAddressLine1 = ApiClient.convertToType(data['deliveryAddressLine1'], 'String');
      if (data.hasOwnProperty('subTotalToDisplay'))
        obj.subTotalToDisplay = ApiClient.convertToType(data['subTotalToDisplay'], 'String');
      if (data.hasOwnProperty('siteDetails'))
        obj.siteDetails = SiteResponse.constructFromObject(data['siteDetails']);
      if (data.hasOwnProperty('customerDetails'))
        obj.customerDetails = BusinessResponse.constructFromObject(data['customerDetails']);
      if (data.hasOwnProperty('orderSequenceNo'))
        obj.orderSequenceNo = ApiClient.convertToType(data['orderSequenceNo'], 'String');
      if (data.hasOwnProperty('invoiceSequenceNo'))
        obj.invoiceSequenceNo = ApiClient.convertToType(data['invoiceSequenceNo'], 'String');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('buildingDetails'))
        obj.buildingDetails = BuildingResponse.constructFromObject(data['buildingDetails']);
      if (data.hasOwnProperty('subTotal'))
        obj.subTotal = ApiClient.convertToType(data['subTotal'], 'String');
      if (data.hasOwnProperty('markUpToDisplay'))
        obj.markUpToDisplay = ApiClient.convertToType(data['markUpToDisplay'], 'String');
      if (data.hasOwnProperty('deliveryDate'))
        obj.deliveryDate = ApiClient.convertToType(data['deliveryDate'], 'Date');
      if (data.hasOwnProperty('shipTogether'))
        obj.shipTogether = ApiClient.convertToType(data['shipTogether'], 'Boolean');
      if (data.hasOwnProperty('quotationValueToDisplay'))
        obj.quotationValueToDisplay = ApiClient.convertToType(data['quotationValueToDisplay'], 'String');
      if (data.hasOwnProperty('currencyCode'))
        obj.currencyCode = ApiClient.convertToType(data['currencyCode'], 'String');
      if (data.hasOwnProperty('orderId'))
        obj.orderId = ApiClient.convertToType(data['orderId'], 'String');
      if (data.hasOwnProperty('clientId'))
        obj.clientId = ApiClient.convertToType(data['clientId'], 'String');
      if (data.hasOwnProperty('nettCost'))
        obj.nettCost = ApiClient.convertToType(data['nettCost'], 'String');
      if (data.hasOwnProperty('locationId'))
        obj.locationId = ApiClient.convertToType(data['locationId'], 'String');
      if (data.hasOwnProperty('clientReferenceNumber'))
        obj.clientReferenceNumber = ApiClient.convertToType(data['clientReferenceNumber'], 'String');
      if (data.hasOwnProperty('nettCostToDisplay'))
        obj.nettCostToDisplay = ApiClient.convertToType(data['nettCostToDisplay'], 'String');
      if (data.hasOwnProperty('buildingId'))
        obj.buildingId = ApiClient.convertToType(data['buildingId'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('addressLine4'))
        obj.addressLine4 = ApiClient.convertToType(data['addressLine4'], 'String');
      if (data.hasOwnProperty('total'))
        obj.total = ApiClient.convertToType(data['total'], 'String');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('deliveryAddressLine2'))
        obj.deliveryAddressLine2 = ApiClient.convertToType(data['deliveryAddressLine2'], 'String');
      if (data.hasOwnProperty('actualCompletionDate'))
        obj.actualCompletionDate = ApiClient.convertToType(data['actualCompletionDate'], 'Date');
      if (data.hasOwnProperty('deliveryCharge'))
        obj.deliveryCharge = ApiClient.convertToType(data['deliveryCharge'], 'String');
      if (data.hasOwnProperty('notes'))
        obj.notes = ApiClient.convertToType(data['notes'], 'String');
      if (data.hasOwnProperty('dateCreatedToDisplay'))
        obj.dateCreatedToDisplay = ApiClient.convertToType(data['dateCreatedToDisplay'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('totalToDisplay'))
        obj.totalToDisplay = ApiClient.convertToType(data['totalToDisplay'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('invoiceList'))
        obj.invoiceList = ApiClient.convertToType(data['invoiceList'], [InvoiceV2Response]);
      if (data.hasOwnProperty('deliverySequenceNo'))
        obj.deliverySequenceNo = ApiClient.convertToType(data['deliverySequenceNo'], 'String');
      if (data.hasOwnProperty('collectionDate'))
        obj.collectionDate = ApiClient.convertToType(data['collectionDate'], 'Date');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('vat'))
        obj.vat = ApiClient.convertToType(data['vat'], 'String');
      if (data.hasOwnProperty('locationDetails'))
        obj.locationDetails = LocationResponse.constructFromObject(data['locationDetails']);
      if (data.hasOwnProperty('deliveryCity'))
        obj.deliveryCity = ApiClient.convertToType(data['deliveryCity'], 'String');
      if (data.hasOwnProperty('clientUserId'))
        obj.clientUserId = ApiClient.convertToType(data['clientUserId'], 'String');
      if (data.hasOwnProperty('addressLine3'))
        obj.addressLine3 = ApiClient.convertToType(data['addressLine3'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} vatToDisplay
   */
  exports.prototype.vatToDisplay = undefined;

  /**
   * @member {String} deliveryPostcode
   */
  exports.prototype.deliveryPostcode = undefined;

  /**
   * @member {String} siteId
   */
  exports.prototype.siteId = undefined;

  /**
   * @member {Date} collectedDate
   */
  exports.prototype.collectedDate = undefined;

  /**
   * @member {String} deliveryDateToDisplay
   */
  exports.prototype.deliveryDateToDisplay = undefined;

  /**
   * @member {String} markUp
   */
  exports.prototype.markUp = undefined;

  /**
   * @member {String} quotationValue
   */
  exports.prototype.quotationValue = undefined;

  /**
   * @member {Array.<module:model/IInvoiceItemV2Response>} invoiceItemResponseList
   */
  exports.prototype.invoiceItemResponseList = undefined;

  /**
   * @member {Date} targetCompletionDate
   */
  exports.prototype.targetCompletionDate = undefined;

  /**
   * @member {Array.<module:model/IDeliveryItemV2Request>} deliveryItemList
   */
  exports.prototype.deliveryItemList = undefined;

  /**
   * @member {String} deliveryChargeToDisplay
   */
  exports.prototype.deliveryChargeToDisplay = undefined;

  /**
   * @member {String} specificAddressRequired
   */
  exports.prototype.specificAddressRequired = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Array.<String>} fileUrls
   */
  exports.prototype.fileUrls = undefined;

  /**
   * @member {String} longDescription
   */
  exports.prototype.longDescription = undefined;

  /**
   * @member {Date} dateOrderReceived
   */
  exports.prototype.dateOrderReceived = undefined;

  /**
   * @member {String} dateOrderReceivedToDisplay
   */
  exports.prototype.dateOrderReceivedToDisplay = undefined;

  /**
   * @member {Array.<String>} imageUrls
   */
  exports.prototype.imageUrls = undefined;

  /**
   * @member {Array.<module:model/IInvoiceItemV2Request>} invoiceItemList
   */
  exports.prototype.invoiceItemList = undefined;

  /**
   * @member {String} shortDescription
   */
  exports.prototype.shortDescription = undefined;

  /**
   * @member {String} deliveryAddressLine1
   */
  exports.prototype.deliveryAddressLine1 = undefined;

  /**
   * @member {String} subTotalToDisplay
   */
  exports.prototype.subTotalToDisplay = undefined;

  /**
   * @member {module:model/SiteResponse} siteDetails
   */
  exports.prototype.siteDetails = undefined;

  /**
   * @member {module:model/BusinessResponse} customerDetails
   */
  exports.prototype.customerDetails = undefined;

  /**
   * @member {String} orderSequenceNo
   */
  exports.prototype.orderSequenceNo = undefined;

  /**
   * @member {String} invoiceSequenceNo
   */
  exports.prototype.invoiceSequenceNo = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {module:model/BuildingResponse} buildingDetails
   */
  exports.prototype.buildingDetails = undefined;

  /**
   * @member {String} subTotal
   */
  exports.prototype.subTotal = undefined;

  /**
   * @member {String} markUpToDisplay
   */
  exports.prototype.markUpToDisplay = undefined;

  /**
   * @member {Date} deliveryDate
   */
  exports.prototype.deliveryDate = undefined;

  /**
   * @member {Boolean} shipTogether
   */
  exports.prototype.shipTogether = undefined;

  /**
   * @member {String} quotationValueToDisplay
   */
  exports.prototype.quotationValueToDisplay = undefined;

  /**
   * @member {String} currencyCode
   */
  exports.prototype.currencyCode = undefined;

  /**
   * @member {String} orderId
   */
  exports.prototype.orderId = undefined;

  /**
   * @member {String} clientId
   */
  exports.prototype.clientId = undefined;

  /**
   * @member {String} nettCost
   */
  exports.prototype.nettCost = undefined;

  /**
   * @member {String} locationId
   */
  exports.prototype.locationId = undefined;

  /**
   * @member {String} clientReferenceNumber
   */
  exports.prototype.clientReferenceNumber = undefined;

  /**
   * @member {String} nettCostToDisplay
   */
  exports.prototype.nettCostToDisplay = undefined;

  /**
   * @member {String} buildingId
   */
  exports.prototype.buildingId = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} addressLine4
   */
  exports.prototype.addressLine4 = undefined;

  /**
   * @member {String} total
   */
  exports.prototype.total = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {String} deliveryAddressLine2
   */
  exports.prototype.deliveryAddressLine2 = undefined;

  /**
   * @member {Date} actualCompletionDate
   */
  exports.prototype.actualCompletionDate = undefined;

  /**
   * @member {String} deliveryCharge
   */
  exports.prototype.deliveryCharge = undefined;

  /**
   * @member {String} notes
   */
  exports.prototype.notes = undefined;

  /**
   * @member {String} dateCreatedToDisplay
   */
  exports.prototype.dateCreatedToDisplay = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} totalToDisplay
   */
  exports.prototype.totalToDisplay = undefined;

  /**
   * @member {String} status
   */
  exports.prototype.status = undefined;

  /**
   * @member {Array.<module:model/InvoiceV2Response>} invoiceList
   */
  exports.prototype.invoiceList = undefined;

  /**
   * @member {String} deliverySequenceNo
   */
  exports.prototype.deliverySequenceNo = undefined;

  /**
   * @member {Date} collectionDate
   */
  exports.prototype.collectionDate = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {String} vat
   */
  exports.prototype.vat = undefined;

  /**
   * @member {module:model/LocationResponse} locationDetails
   */
  exports.prototype.locationDetails = undefined;

  /**
   * @member {String} deliveryCity
   */
  exports.prototype.deliveryCity = undefined;

  /**
   * @member {String} clientUserId
   */
  exports.prototype.clientUserId = undefined;

  /**
   * @member {String} addressLine3
   */
  exports.prototype.addressLine3 = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/InvoiceV2Response.js